export class HomeViewEvent {
    event: string = 'homeView';
}